module.exports = __webpack_public_path__ + "media/images/game/how_it_works/ulohy-77e13970bf878744c636aa10acff2561.png";